"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../../Flex"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2.default)(),
      colors = _useTheme.colors,
      spacing = _useTheme.spacing;

  return {
    root: {
      backgroundColor: colors.white,
      boxSizing: 'border-box',
      margin: spacing(-1, 0),
      '& > *': {
        margin: spacing(1, 0),
        justifyContent: 'flex-start'
      }
    }
  };
};

__signature__(useStyles, "useTheme{{ colors, spacing }}", function () {
  return [_useTheme2.default];
});

var Links = function Links(props) {
  var children = props.children;
  var classes = useStyles();
  return (0, _core.jsx)(_Flex.default, {
    css: classes.root,
    width: "100%",
    flexDirection: "column",
    padding: [4, 2],
    alignItems: "stretch"
  }, children);
};

__signature__(Links, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Links;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/Links.tsx");
  reactHotLoader.register(Links, "Links", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/Links.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/Links.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9SZXNwb25zaXZlSGVhZGVyL01vYmlsZS9MaW5rcy50c3giXSwibmFtZXMiOlsidXNlU3R5bGVzIiwiY29sb3JzIiwic3BhY2luZyIsInJvb3QiLCJiYWNrZ3JvdW5kQ29sb3IiLCJ3aGl0ZSIsImJveFNpemluZyIsIm1hcmdpbiIsImp1c3RpZnlDb250ZW50IiwidXNlVGhlbWUiLCJMaW5rcyIsInByb3BzIiwiY2hpbGRyZW4iLCJjbGFzc2VzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQTs7QUFFQTs7QUFDQTs7Ozs7Ozs7Ozs7OztBQUVBLElBQU1BLFNBQVMsR0FBRyxTQUFaQSxTQUFZLEdBQU07QUFBQSxrQkFDTSx5QkFETjtBQUFBLE1BQ2RDLE1BRGMsYUFDZEEsTUFEYztBQUFBLE1BQ05DLE9BRE0sYUFDTkEsT0FETTs7QUFFdEIsU0FBTztBQUNMQyxJQUFBQSxJQUFJLEVBQUU7QUFDSkMsTUFBQUEsZUFBZSxFQUFFSCxNQUFNLENBQUNJLEtBRHBCO0FBRUpDLE1BQUFBLFNBQVMsRUFBRSxZQUZQO0FBR0pDLE1BQUFBLE1BQU0sRUFBRUwsT0FBTyxDQUFDLENBQUMsQ0FBRixFQUFLLENBQUwsQ0FIWDtBQUlKLGVBQVM7QUFDUEssUUFBQUEsTUFBTSxFQUFFTCxPQUFPLENBQUMsQ0FBRCxFQUFJLENBQUosQ0FEUjtBQUVQTSxRQUFBQSxjQUFjLEVBQUU7QUFGVDtBQUpMO0FBREQsR0FBUDtBQVdELENBYkQ7O2NBQU1SLFM7VUFDd0JTLGtCOzs7QUFjOUIsSUFBTUMsS0FBd0IsR0FBRyxTQUEzQkEsS0FBMkIsQ0FBQ0MsS0FBRCxFQUFXO0FBQUEsTUFDbENDLFFBRGtDLEdBQ3JCRCxLQURxQixDQUNsQ0MsUUFEa0M7QUFHMUMsTUFBTUMsT0FBTyxHQUFHYixTQUFTLEVBQXpCO0FBRUEsU0FDRSxlQUFDLGFBQUQ7QUFBTSxJQUFBLEdBQUcsRUFBRWEsT0FBTyxDQUFDVixJQUFuQjtBQUF5QixJQUFBLEtBQUssRUFBQyxNQUEvQjtBQUFzQyxJQUFBLGFBQWEsRUFBQyxRQUFwRDtBQUE2RCxJQUFBLE9BQU8sRUFBRSxDQUFDLENBQUQsRUFBSSxDQUFKLENBQXRFO0FBQThFLElBQUEsVUFBVSxFQUFDO0FBQXpGLEtBQ0dTLFFBREgsQ0FERjtBQUtELENBVkQ7O2NBQU1GLEs7VUFHWVYsUzs7O2VBU0hVLEs7Ozs7Ozs7Ozs7OzswQkEzQlRWLFM7MEJBZUFVLEsiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCBGbGV4IGZyb20gJy4uLy4uL0ZsZXgnO1xuaW1wb3J0IHVzZVRoZW1lIGZyb20gJy4uLy4uL3N0eWxlcy91c2VUaGVtZSc7XG5cbmNvbnN0IHVzZVN0eWxlcyA9ICgpID0+IHtcbiAgY29uc3QgeyBjb2xvcnMsIHNwYWNpbmcgfSA9IHVzZVRoZW1lKCk7XG4gIHJldHVybiB7XG4gICAgcm9vdDoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiBjb2xvcnMud2hpdGUsXG4gICAgICBib3hTaXppbmc6ICdib3JkZXItYm94JyxcbiAgICAgIG1hcmdpbjogc3BhY2luZygtMSwgMCksXG4gICAgICAnJiA+IConOiB7XG4gICAgICAgIG1hcmdpbjogc3BhY2luZygxLCAwKSxcbiAgICAgICAganVzdGlmeUNvbnRlbnQ6ICdmbGV4LXN0YXJ0JyxcbiAgICAgIH0sXG4gICAgfSxcbiAgfSBhcyBjb25zdDtcbn07XG5cbmNvbnN0IExpbmtzOiBGdW5jdGlvbkNvbXBvbmVudCA9IChwcm9wcykgPT4ge1xuICBjb25zdCB7IGNoaWxkcmVuIH0gPSBwcm9wcztcblxuICBjb25zdCBjbGFzc2VzID0gdXNlU3R5bGVzKCk7XG5cbiAgcmV0dXJuIChcbiAgICA8RmxleCBjc3M9e2NsYXNzZXMucm9vdH0gd2lkdGg9XCIxMDAlXCIgZmxleERpcmVjdGlvbj1cImNvbHVtblwiIHBhZGRpbmc9e1s0LCAyXX0gYWxpZ25JdGVtcz1cInN0cmV0Y2hcIj5cbiAgICAgIHtjaGlsZHJlbn1cbiAgICA8L0ZsZXg+XG4gICk7XG59O1xuXG5leHBvcnQgZGVmYXVsdCBMaW5rcztcbiJdfQ==